import { render, staticRenderFns } from "./CreateCustomerForm.vue?vue&type=template&id=cab04e7c"
import script from "./CreateCustomerForm.vue?vue&type=script&lang=js"
export * from "./CreateCustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomerForm.vue?vue&type=style&index=0&id=cab04e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports